





































































































































import Vue from 'vue';
import 'codemirror/mode/css/css.js';
import 'codemirror/theme/rubyblue.css';

export default Vue.extend({
  name: 'Editor',
  props: ['apiInfo', 'expandsEditor'],
  watch: {
    apiInfo: {
      handler(val) {
        this.codeDescription = this.convertComments(val.description, 'apply');
        this.editHistory = [];
      },
      deep: true,
    },
  },
  computed: {},
  data() {
    return {
      option: {
        tabSize: 2,
        mode: 'text/javascript',
        styleActiveLine: true,
        theme: 'rubyblue',
        lineNumbers: true,
        line: true,
      },

      codeDescription: '',
      editHistory: [] as string[],
      error: '' as any,
      evaluatedObject: null,
    };
  },
  methods: {
    convertComments(str: string, type: 'apply' | 'clear') {
      const editor =
        type === 'apply'
          ? (line: string = '') => `//  ${line}`
          : (str: string) => str.replace(/^\/\/ .*$/, '');
      return str
        .split('\n')
        .map(editor)
        .filter(str => str !== '')
        .join('\n');
    },
    evaluateOnJS(requestParam: string) {
      const p = requestParam.replace(/;/g, '');
      const d = eval(`(${p})`);
      // extract Date Object from string type date value ('YYYY-MM-DD') in prm
      return (JSON as any).parseWithDate(JSON.stringify(d));
    },
    handleOnChangeEditorInput(code: string) {
      try {
        const requestParamCode = this.convertComments(code, 'clear');
        this.evaluatedObject = this.evaluateOnJS(requestParamCode);
        this.error = null;
      } catch (e) {
        this.error = `${e}`;
      }
    },
    handleOnClickMagicWand() {
      this.editHistory.push(this.codeDescription);
      this.codeDescription = this.codeDescription
        .split('\n')
        .filter(str => !/\/\*\*/.test(str))
        .filter(str => !/ \* /.test(str))
        .filter(str => !/\*\//.test(str))
        .map(str => str.replace(/^.*export type.*/, ''))
        .map(str => str.replace(/(^.*)export interface.*/, '$1{'))
        .filter(str => !!str && str !== '')
        .join('\n');
    },
    handleOnClickDeleteComment() {
      this.editHistory.push(this.codeDescription);
      this.codeDescription = this.codeDescription
        .split('\n')
        .filter(str => !/\/\*\*/.test(str))
        .filter(str => !/ \* /.test(str))
        .filter(str => !/\*\//.test(str))
        .map(str => str.replace(/^\/\/ +/, ''))
        .filter(str => !!str && str !== '')
        .join('\n');
    },
    handleOnClickNeedle() {
      this.editHistory.push(this.codeDescription);
      this.codeDescription = this.codeDescription
        .split('\n')
        .map(str => {
          // checks this line is either a definiton for minimum value or not.
          // e.g. `test_key?: string,` shuold be matched (and then replace value to a dummy value)
          const match = /^.*\w+(\?:|:) +(.*)/.exec(str);
          if (match === null || match.length < 2) {
            return str;
          }

          const type = match[2].replace(',', '');
          let replacedLine: string = str;
          switch (type) {
            case 'string':
              return str.replace('?:', ':').replace(type, '"SampleValue"');
              break;
            case 'number':
              return str.replace('?:', ':').replace(type, '1');
              break;
            case 'boolean':
              return str.replace('?:', ':').replace(type, 'true');
              break;
            case 'Array<string>':
              return str.replace('?:', ':').replace(type, '["SampleValue"]');
              break;
            case 'Array<number>':
              return str.replace('?:', ':').replace(type, '[1]');
              break;
            case 'Array<boolean>':
              return str.replace('?:', ':').replace(type, '[true]');
              break;
            default:
              return str;
          }
        })
        .filter(str => !!str && str !== '')
        .join('\n');
    },
    handleOnClickUndo() {
      this.codeDescription = this.editHistory.pop() || '';
    },
    handleOnClickDelete() {
      this.editHistory.push('');
      this.codeDescription = '';
    },
    handleOnClickDownload() {
      let anchor = document.createElement('a');
      anchor.href =
        'data:text;charset=utf-8,' + encodeURI(this.codeDescription);
      anchor.target = '_blank';
      anchor.download = `${this.apiInfo.className}_${this.apiInfo.methodName}.js`;
      anchor.click();
    },
    handleOnClickUpload(e: Event) {
      const input = e.target as any;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent) =>
          (this.codeDescription = reader.result as string);
        reader.onerror = (e: ProgressEvent) =>
          window.alert('failed to upload.');
        reader.readAsText(input.files[0]);
      }
    },
  },
});
